import React from "react";
import { RoutePermittedRole } from "shared/constants/AppConst";
const UserManagementMaster = React.lazy(() => import("./user"));
const DepartmentMaster = React.lazy(() => import("./department"));
const LocationAuthoritiesMaster = React.lazy(() => import("./location"));
export const MasterConfig = [
    {
        permittedRole: [RoutePermittedRole.SUPER_ADMIN,],
        path: "/master/user",
        element: <UserManagementMaster />,
    },
    {
        permittedRole: [RoutePermittedRole.SUPER_ADMIN,],
        path: "/master/department",
        element: <DepartmentMaster />,
    },
    {
        permittedRole: [RoutePermittedRole.SUPER_ADMIN,],
        path: "/master/location-authorities",
        element: <LocationAuthoritiesMaster />,
    },
];
